export default "__VITE_ASSET__dedd6a3f__"